import { useEffect, useRef, useState } from 'react';
import { LockKeyhole } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';

const COPY = {
  cold_call: ['Cold Call', 'Du möchtest auch durch telefonische Neukundengewinnung zusätzliche Abschlusschancen schaffen und mehr verdienen?'],
  my_contacts: ['Meine Kontakte', 'Du möchtest auch dein eigenes Netzwerk nutzen, Kontakte systematisch begleiten und daraus neue Verdienstmöglichkeiten entwickeln?'],
  promo: ['Promotion', 'Du möchtest auch unterwegs neue Kontakte gewinnen und sie schneller zu echten Abschlusschancen entwickeln?'],
  opportunities: ['Chancen', 'Du möchtest auch deine Verkaufschancen gezielt bis zum Abschluss begleiten und dein Verdienstpotenzial besser ausschöpfen?'],
  referrals: ['Empfehlungen', 'Du möchtest auch über Empfehlungen neue Kunden gewinnen und mit persönlichen Kontakten schneller vorwärtskommen?'],
  analytics: ['Zahlen & Pipeline', 'Du möchtest auch erkennen, welche Aktivitäten zu Abschlüssen führen, und deine Zeit gezielter für mehr Verdienst einsetzen?'],
  home: ['Dein Vertriebsfokus', 'Du möchtest auch deine nächsten Aktivitäten und Ziele auf einen Blick sehen und schneller auf neue Abschlüsse hinarbeiten?'],
};
export function showLockedArea(area) {
  window.dispatchEvent(new CustomEvent('ls:locked-area', { detail: area }));
}
export default function LockedAreaDialog() {
  const [area, setArea] = useState(null);
  const trigger = useRef(null);
  useEffect(() => {
    const open = e => { trigger.current = document.activeElement; setArea(e.detail || 'other'); };
    window.addEventListener('ls:locked-area', open);
    return () => window.removeEventListener('ls:locked-area', open);
  }, []);
  const [title, text] = COPY[area] || ['Weitere Möglichkeiten', 'Du möchtest auch diesen Bereich nutzen, zusätzliche Verdienstmöglichkeiten entdecken und schneller vorwärtskommen?'];
  return <Dialog open={area !== null} onOpenChange={open => { if (!open) setArea(null); }}>
    <DialogContent className="border-amber-400/30 bg-[#0b1019] text-slate-100 rounded-2xl" data-testid="locked-area-dialog"
      onEscapeKeyDown={() => setArea(null)} onCloseAutoFocus={e => { e.preventDefault(); trigger.current?.focus(); }}>
      <DialogHeader><LockKeyhole className="w-8 h-8 text-amber-300 mb-2"/><DialogTitle>{title}</DialogTitle>
        <DialogDescription className="text-slate-300 leading-relaxed pt-3">{text}</DialogDescription></DialogHeader>
      <p className="text-sm leading-relaxed text-slate-300">Sprich deinen Teamleiter an und frag ihn, wie du auch in diesem Bereich aktiv werden kannst.</p>
      <button className="gold-btn rounded-xl py-3 font-semibold" onClick={() => setArea(null)}>Verstanden</button>
    </DialogContent>
  </Dialog>;
}
